import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationCustomers(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.CUSTOMERS, { keyPrefix });

  return t;
}

export default useTranslationCustomers;
